module.exports = __webpack_public_path__ + "static/oseguera-1e31dd5f21bf631fc8099b10c9cc5d81.jpg";